
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { Language } from '../types';
import { useUser } from './UserContext';

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useUser();
  const [language, setLanguageState] = useState<Language>('ru');

  useEffect(() => {
    const key = user ? `language_${user.uid}` : 'language';
    const saved = localStorage.getItem(key) as Language | null;
    if (saved) {
      setLanguageState(saved);
    }
  }, [user]);

  const setLanguage = useCallback((lang: Language) => {
    setLanguageState(lang);
    const key = user ? `language_${user.uid}` : 'language';
    localStorage.setItem(key, lang);
  }, [user]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within a LanguageProvider');
  return context;
};
